"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldSkipGraphqlQuery = void 0;
const shouldSkipGraphqlQuery = ({
  isAnonymousUser,
  isScriptLoaded
}) => isAnonymousUser || !isScriptLoaded;
exports.shouldSkipGraphqlQuery = shouldSkipGraphqlQuery;
